import { render, staticRenderFns } from "./Addposition.vue?vue&type=template&id=6abc6eb6&"
import script from "./Addposition.vue?vue&type=script&lang=js&"
export * from "./Addposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports